/**
 * Protected Route Component
 *
 * Guards routes that require configuration (tenantId + jwtSecret).
 * Redirects unconfigured users to the landing page.
 *
 * Note: This only checks if configuration exists locally.
 * Actual access validation happens server-side when API calls are made.
 */

import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAccess } from '../lib/auth-context';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isConfigured } = useAccess();
  const location = useLocation();

  if (!isConfigured) {
    // Redirect to landing page, preserving the intended destination
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
